// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Radio, Segment, Label, Grid, Container, Button, Icon } from 'semantic-ui-react'
import fire from '../config/Fire'

export default class UserMgmt extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      error: null
    }
  }

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        let raw = user.email
        let userUnderscore = raw.replace(/\./g, '_')
        this.setState({
          userUnderscore: userUnderscore
        })
        this.userData()
      } else {
        this.props.history.push('/')
      }
    })
  }

  userData = (e) => {
    fetch('https://murkstomstag.herokuapp.com/api/v1/user/mgmt', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore
      })
    })
      .then((response) => {
        return response.json()
      })
      .then((obj) => {
        if ((obj.code = 200)) {
          this.setState({
            emailAuth: obj.emailAuth,
            twitterAuth: obj.twitterAuth,
            googleAuth: obj.googleAuth,
            loading: false
          })
        } else {
          this.setState({
            loading: false,
            error: 'Internal Server Error |  code 500'
          })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  editAuth = (e) => {
    e.preventDefault()
    this.setState({ loading: true })
    const objMGMT = {
      emailAuth: this.state.emailAuth,
      googleAuth: this.state.googleAuth,
      twitterAuth: this.state.twitterAuth
    }
    const cloneMGMT = { ...objMGMT }
    Object.keys(objMGMT).forEach((key) => {
      if (!cloneMGMT[key]) cloneMGMT[key] = null
    })
    fetch('https://murkstomstag.herokuapp.com/api/v1/manage/auth', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userUnderscore: this.state.userUnderscore,
        cloneMGMT: cloneMGMT
      })
    })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ loading: false, saved: true, saving: false })
          setTimeout(
            function () {
              this.setState({
                saved: false
              })
            }.bind(this),
            2000
          )
        } else {
          this.setState({ error: 'Error ' + response.status, loading: false })
        }
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error: error.message, loading: false })
      })
  }

  googleToggle = () =>
    this.setState((prevState) => ({
      googleAuth: !this.state.googleAuth,
      edit: true
    }))
  twitterToggle = () =>
    this.setState((prevState) => ({
      twitterAuth: !this.state.twitterAuth,
      edit: true
    }))
  emailToggle = () =>
    this.setState((prevState) => ({
      emailAuth: !this.state.emailAuth,
      edit: true
    }))

  render () {
    let { googleAuth, twitterAuth, emailAuth, loading, error, edit, saved } = this.state

    return (
      <Container className='masterdiv'>
        <div className='mb center'>
          <h2>User Auth Management</h2>
          <p>
            <Icon name='exclamation triangle' color='yellow' />
            This feature is under maintenance.
          </p>
          <Button
            loading={loading}
            disabled={!edit}
            error={error}
            content={!saved ? 'Save' : 'Saved successfully!'}
            onClick={this.editAuth}
            color={!saved ? 'black' : 'green'}
          />
        </div>

        <Grid centered stackable verticalAlign='top' fluid>
          <Grid.Column width='4' />
          <Grid.Column width='8'>
            <Segment padded fluid>
              <Label size='small'>Email</Label>
              <h5>
                Authenticate users with their email addresses and passwords. Murkstom also handles
                password reset emails. Backend is powered by Google Firebase.
              </h5>
              <Radio toggle onChange={this.emailToggle} checked={emailAuth} />
            </Segment>

            <Segment padded fluid>
              <Label size='small'>Google Auth</Label>
              <h5>
                You can let your users authenticate using their Google accounts by integrating
                Google Sign-in into your app.
              </h5>
              <Radio toggle onChange={this.googleToggle} checked={googleAuth} />
            </Segment>

            <Segment padded fluid>
              <Label size='small'>Twitter Auth</Label>
              <h5>
                You can let your users authenticate using their Twitter accounts by integrating
                Twitter authentication into your app.
              </h5>
              <Radio toggle onChange={this.twitterToggle} checked={twitterAuth} />
            </Segment>
          </Grid.Column>
          <Grid.Column width='4' />
        </Grid>
      </Container>
    )
  }
}
